import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";


export const OrganizatonMailFormData = {
    name: "Organization Email From",
    initialState: { organizationMailConfigId: 0, organizationId:0, smtpServer: "", port: "" ,useSSL: false,    emailSender :"",password: ""},
  
    section: [
        {
            sectionId: 'OrganizationEmail',
            title: "Organization Email Section",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-12 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>, 
            fields: [
                {
                    id: "smtpServer",
                    label: "SMTP Server",
                    Field_Name: "server name",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "smtpServer",
                    fieldSetting: {
                        placeholder: "Please Enter Server",
                        allowSpace: true,
                       
                    },
                     validation: [{ type: validationTypes.REQUIRE }],
                        style: {
                        containerCss: "col-lg-6 col-xl-6 col-md-6 mb-2",
                    },
                }, 
                {
                    id: "port",
                    label: "Port",
                    Field_Name: "Port",
                    fieldType: FormFieldTypes.NUMERIC,
                    dataField: "port",
                    fieldSetting: {
                        placeholder: "Please Enter Port",
                        allowSpace: false,
                        MaskInputType:true,
                        
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                        style: {
                            containerCss: "col-lg-6 col-xl-6 col-md-6 mb-2 ",
                        },
                },
                
                {
                    id: "emailSender",
                    label: "Email Sender",
                    Field_Name: "email sender",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "emailSender",
                    fieldSetting: {
                        placeholder: "Please Enter Email Sender",
                        allowSpace: true,
                       
                    },
                     validation: [{ type: validationTypes.EMAIL }],
                     style: {
                        containerCss: "col-lg-6 col-xl-6 col-md-6 mb-2",
                      },
                },
                {
                    id: "password",
                    label: "password ",
                    Field_Name: "password",
                    fieldType: FormFieldTypes.PASSWORD,
                    dataField: "password",
                    fieldSetting: {
                        placeholder: "Please Enter App Password",
                       
                    },
                     validation: [{ type: validationTypes.PASSWORD }],
                     style: {
                        containerCss: "col-lg-6 col-xl-6 col-md-6 mb-2",
                      },
                },
                {
                    id: "useSsl",
                    label: "UseSSL",
                    Field_Name: "usessl",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "useSSL",
                    fieldSetting: {
                        allowSpace: true,
                      },
                    style: {
                        containerCss: "col-lg-6 col-md-6 mb-2 double-label-sec checkbox-style mt-3",
                      },
                },
             ]
        }
    ]
};

// formFields: [
       
    // {
    //     id: "smtpServer",
    //     label: "SMTP Server",
    //     Field_Name: "Server Name",
    //     fieldType: FormFieldTypes.INPUT,
    //     dataField: "smtpServer",
    //     fieldSetting: {
    //         placeholder: "Enter Server",
    //         allowSpace: true,
           
    //     },
    //      validation: [{ type: validationTypes.REQUIRE }],
    //         style: {
    //         containerCss: "col-lg-6 col-xl-6 col-md-6 mb-2",
    //     },
    // }, 
    // {
    //     id: "port",
    //     label: "Port",
    //     Field_Name: "Port",
    //     fieldType: FormFieldTypes.NUMERIC,
    //     dataField: "port",
    //     fieldSetting: {
    //         placeholder: "Enter Port",
    //         allowSpace: false,
            
    //     },
    //     validation: [{ type: validationTypes.REQUIRE },{ type: "number" }],
    //         style: {
    //             containerCss: "col-lg-6 col-xl-6 col-md-6 mb-2 ",
    //         },
    // },
    
    // {
    //     id: "emailSender",
    //     label: "Email Sender",
    //     Field_Name: "Email Sender",
    //     fieldType: FormFieldTypes.INPUT,
    //     dataField: "emailSender",
    //     fieldSetting: {
    //         placeholder: "Enter Email Sender",
    //         allowSpace: true,
           
    //     },
    //      validation: [{ type: validationTypes.REQUIRE }],
    //      style: {
    //         containerCss: "col-lg-6 col-xl-6 col-md-6 mb-2",
    //       },
    // },
    // {
    //     id: "password",
    //     label: "password ",
    //     Field_Name: "Password",
    //     fieldType: FormFieldTypes.PASSWORD,
    //     dataField: "password",
    //     fieldSetting: {
    //         placeholder: "Enter Your App Password",
           
    //     },
    //      validation: [{ type: validationTypes.REQUIRE }],
    //      style: {
    //         containerCss: "col-lg-6 col-xl-6 col-md-6 mb-2",
    //       },
    // },
    // {
    //     id: "useSsl",
    //     label: "UseSSL",
    //     Field_Name: "UseSSL",
    //     fieldType: FormFieldTypes.CHECKBOX,
    //     dataField: "useSSL",
    //     // fieldSetting: {
    //     //   placeholder: "",
    //     // },
    //     //  validation: [{ type: validationTypes.REQUIRE }],
    //     style: {
    //         containerCss: "col-1 mt-0 validation-left-0 checkbox-style",
    //       },
    // },
// ],